export const getEmpDesignation = (employee) => {
  if (!employee) return "";

  if (employee.EmpAuthLevel === "L0") return "Admin";
  if (employee.EmpAuthLevel === "L1") return "Director";

  if (employee.EmpAuthLevel === "L2") return "Finance Dept";
  if (employee.EmpAuthLevel === "L5") return "Accounting Dept";

  if (employee.EmpAuthLevel === "L3") return "Sales Person";

  if (employee.EmpAuthLevel === "L4") {
    if (employee.customRoles?.includes("operations")) {
      return `${employee.servicetype} Employee`;
    }
    if (employee.customRoles?.includes("project manager")) {
      return `${employee.servicetype} Manager`;
    }
    return "";
  }

  return "Unknown";
};
